<template>
  <div
    class="banner-container"
    :style="{ 'margin-bottom': 'var(--media-gap)' }"
    role="region"
    aria-label="Likeshop Banner"
  >
    <div class="banner-frame">
      <LikeShopItem :media="banner" :media-size="mediaSize" :default-alt-text="'Banner Image'" />
    </div>
  </div>
</template>

<script>
import { useBreakpoints } from '@/composables/useBreakpoints';
import LikeShopItem from '@/components/LikeShopItem.vue';

export default {
  name: 'LikeshopBanner',
  components: {
    LikeShopItem,
  },

  props: {
    banner: { type: Object, required: true },
  },
  setup() {
    const { isMobile } = useBreakpoints();

    return {
      isMobile,
    };
  },
  computed: {
    mediaSize() {
      if (this.isMobile) {
        return this.$config.imageSizes.w640h640;
      }
      return this.$config.imageSizes.w1280h1280;
    },
  },
};
</script>

<style scoped lang="postcss">
.banner-container {
  position: relative;
  width: 100%;
  padding-top: 50%;

  .banner-frame {
    position: absolute;
    inset: 0;

    :deep(.media-container) {
      height: 100%;
      width: 100%;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
